module.exports = __webpack_public_path__ + "media/du-weisst-ja-wie-es-geht.13500acf.mp3";